import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import {
    StoreType,
    SilDeviceType,
    SilDeviceFilters,
    SortSilDevices,
    setSilModelDevicesAccountSubsystemIds,
    setSilModelDevicesAccountSubsystemSort,
    setSilModelDevicesAccountSubsystemFilters,
} from "client/store"
import {
    PageContent,
    Table,
    TableSearchWrapper,
    SortRows,
} from "client/components"

import SilDeviceSearch from "client/pages/search/silDeviceSearch"
import Columns from "./columns"

const AccountSubsystems = () => {
    const deviceList = useSelector((state: StoreType) => state.silModelDevices.accountSubsystems.deviceList)
    const deviceIds = useSelector((state: StoreType) => state.silModelDevices.accountSubsystems.deviceIds)
    const sortColumn = useSelector((state: StoreType) => state.silModelDevices.accountSubsystems.sortColumn)
    const sortOrder = useSelector((state: StoreType) => state.silModelDevices.accountSubsystems.sortOrder)
    const filters = useSelector((state: StoreType) => state.silModelDevices.accountSubsystems.filters)

    const dispatch = useDispatch()

    useEffect(() => {
        const sortedIds = SortSilDevices(Object.values(deviceList), sortColumn, sortOrder, filters)
        dispatch(setSilModelDevicesAccountSubsystemIds(sortedIds))
    }, [deviceList, sortColumn, sortOrder, filters])

    const onSort: SortRows = (column: keyof SilDeviceType, order) => {
        dispatch(setSilModelDevicesAccountSubsystemSort(column, order))
    }

    const onFilter = (newFilters: SilDeviceFilters) => {
        dispatch(setSilModelDevicesAccountSubsystemFilters(newFilters))
    }

    const columns = Columns()

    return (
        <PageContent>
            <TableSearchWrapper>
                <SilDeviceSearch
                    id="accountSubsystems"
                    filters={filters}
                    onFilter={onFilter}
                />
            </TableSearchWrapper>
            <Table
                columns={columns}
                dataList={deviceList}
                dataIds={deviceIds}
                sortColumn={sortColumn}
                sortOrder={sortOrder}
                rowSize="md"
                showPagination
                onSort={onSort}
            />
        </PageContent>
    )
}
export default AccountSubsystems
